export class RequestImpressaoModel {
    public layout: string;
	public numeroDocumento: string;
	public conteudo: string;
	public url: string;
	public grauSigilo: number;
}